<template>
  <div class="login">
    <div class="copyright-txt poa">
      Copyright © 八块钱网, All Rights Reserved.
    </div>
    <div class="login__bg df align-center">
      <img
        src="@/assets/images/login_bg_logo.png"
        alt=""
        class="login__left flex1"
      />
      <el-form
        class="flex1 login-form"
        ref="login_form"
        :model="login_form"
        :rules="login_form.rules"
        label-width="80px"
      >
        <div class="login-title por">
          <img
            src="@/assets/images/company_logo.png"
            alt=""
            class="login-logo poa"
          />
          <img
            src="@/assets/images/system_name.png"
            alt=""
            class="system-name poa"
          />
        </div>
        <div class="login-body">
          <el-form-item label prop="username">
            <el-input
              v-model="login_form.username"
              placeholder="请输入手机号"
              maxlength="11"
              @input="addClassUser"
            >
              <i slot="prefix" class="el-input__icon el-icon-user-solid"></i>
            </el-input>
          </el-form-item>
          <el-form-item label prop="password">
            <el-input
              v-model="login_form.password"
              placeholder="请输入密码"
              type="password"
              @input="addClass"
              @blur="addClass"
            >
              <i slot="prefix" class="el-input__icon iconfont icon-lock"></i>
            </el-input>
          </el-form-item>
          <el-form-item
            :class="[{ Codeactive: verifyCodeActive }, 'verify-code-input']"
            label
          >
            <el-input
              type="number"
              placeholder="请输入验证码"
              v-model="login_form.verifyCode"
              oninput="if(value.length>6)value=value.slice(0,6)"
              @input="addLoginBtnClass"
              @keydown.native="channelInputLimit"
              @keyup.enter.native="loginfn()"
            >
              <i
                slot="prefix"
                class="el-input__icon iconfont icon-renzhengdunpaianquanbaozhangzhibao"
              ></i>
              <template slot="append">
                <span v-if="!verifyCodeActive">{{ verifyCodeStr }}</span>
                <el-button v-else @click="getVerifyCode">获取验证码</el-button>
              </template>
            </el-input>
          </el-form-item>
          <div class="pw-wrap">
            <template>
              <el-checkbox v-model="pwChecked">记住密码</el-checkbox>
              <el-tooltip class="item" effect="light" placement="right">
                <el-link type="primary">忘记密码？</el-link>
                <div slot="content">
                  注：普通管理员忘记密码，请联系对应超级管理员
                  <br />重置密码；超级管理员忘记密码，请联系平台运营
                  <br />（15362660576）重置密码
                </div>
              </el-tooltip>
            </template>
          </div>
          <el-form-item :class="[{ Subactive: submitActive }, 'login-btn']">
            <el-button @click="loginfn">登录</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
  import JSEncrypt from "jsencrypt/bin/jsencrypt";
  export default {
    data() {
      let phoneValidator = (rule, value, callback) => {
        if (!RegExp(/^(0|86|17951)?1(3|4|5|6|7|8|9)[0-9]{9}$/).test(value)) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      };
      return {
        submitActive: false,
        pwChecked: false,
        // 验证码按钮文字
        verifyCodeStr: "获取验证码",
        // 关闭验证码的计时器
        countDownIsClose: false,
        // 验证码的计时器是不是正在计时
        countDownDoing: false,
        // 验证码按钮的active状态
        verifyCodeActive: false,

        login_form: {
          username: "",
          password: "",
          rules: {
            username: [
              { required: true, message: "请输入手机号", trigger: "focus" },
              { required: true, validator: phoneValidator, trigger: "blur" },
            ],
            password: [
              { required: true, message: "请输入密码", trigger: "focus" },
            ],
          },
          verifyCode: "",
        },
      };
    },
    mounted() {
      this.getCookie();
    },
    created() {
      this.keyupEnter();
    },
    methods: {
      channelInputLimit(e) {
        let key = e.key;
        // 不允许输入‘e‘和‘.‘
        if (key === "e" || key === ".") {
          e.returnValue = false;
          return false;
        }
        return true;
      },
      addClass() {
        this.$refs["login_form"].validate((valid) => {
          if (valid && !this.countDownDoing) {
            this.verifyCodeActive = true;
          } else {
            this.verifyCodeActive = false;
          }
        });
      },
      addClassUser() {
        if (
          RegExp(/^(0|86|17951)?1(3|4|5|6|7|8|9)[0-9]{9}$/).test(
            this.login_form.username
          ) &&
          this.login_form.password != ""
        ) {
          this.verifyCodeActive = true;
        } else {
          this.verifyCodeActive = false;
        }
      },
      addLoginBtnClass() {
        if (
          this.login_form.username != "" &&
          this.login_form.password != "" &&
          this.login_form.verifyCode != ""
        ) {
          this.submitActive = true;
        } else {
          this.submitActive = false;
        }
      },
      // removeCountdown () {
      //   if (this.login_form.verifyCode === "") {
      //     this.countDownIsClose = true;
      //   }
      // },

      getVerifyCode() {
        this.countDown(60);
        this.$axios
          .post("/api/v1/admin/verifyCode", {
            mobile: this.login_form.username,
          })
          .then((res) => {
            if (res.data.status == "200") {
              this.$popup("发送成功，请在手机上查看", "success");
              this.$set(this.login_form, "verifyCode", res.data.data.code);
            } else {
              this.$popup(res.data.msg, "error");
            }
          })
          .catch((error) => {
            this.$popup(res.data.msg, "error");
          });
      },
      loginfn() {
        this.$refs["login_form"].validate((valid) => {
          if (valid) {
            this.$axios
              .post("/api/v1/admin/login", {
                mobile: this.encypt(this.login_form.username),
                password: this.encypt(this.login_form.password),
                verify_code: this.login_form.verifyCode,
              })
              .then((res) => {
                if (res.data.status == 200) {
                  if (this.pwChecked == true) {
                    this.setCookie(
                      this.login_form.username,
                      this.login_form.password,
                      this.verifyCodeActive,
                      7
                    );
                  } else {
                    this.clearCookie();
                  }
                  this.$popup(res.data.msg, "success");
                  //本地保存用户信息
                  sessionStorage.setItem("login", true); //登录信息
                  localStorage.setItem("uid", res.data.data.admin.id);
                  localStorage.setItem("name", res.data.data.admin.nickname);
                  localStorage.setItem("avatar", res.data.data.admin.avatar);
                  localStorage.setItem("account_list", JSON.stringify(res.data.data.admin.account_list));
                  setTimeout(() => {
                    if (this.$route.query.redirect == location.hostname) {
                      // 跳回登录之前的页面
                      this.$router.go(-1);
                    } else {
                      this.$router.push({
                        path: "/home",
                      });
                    }
                  }, 2000);
                } else {
                  this.$popup(res.data.msg, "error");
                }
              })
              .catch((error) => {
                this.$popup(res.data.msg, "error");
              });
          }
        });
      },
      encypt(password) {
        let encryptor = new JSEncrypt(); // 新建JSEncrypt对象

        let publicKey = `-----BEGIN PUBLIC KEY-----
            MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC0e6STNr46dBUBAnGhotyZ6/qy
            eLsqBvHJPcSXwzLtdbq3HUOD7N539ykklFCQR6TN0rfzI6dexUIEPFcFpVMVdZd2
            GBOZjhlrtEQ7OlhXkdL96A2QcWPwFX1E9CO6tjNd60EJ/H0PU2UM26YsuCjaP6hw
            4wbmjV/piJ0jpMgu0wIDAQAB
            -----END PUBLIC KEY-----`; //把之前生成的贴进来，实际开发过程中，可以是后台传过来的

        encryptor.setPublicKey(publicKey); // 设置公钥

        let rsaPassWord = encryptor.encrypt(password); // 对需要加密的数据进行加密
        return rsaPassWord;
      },
      // 绑定回车
      keyupEnter() {
        document.onkeydown = (e) => {
          let body = document.getElementsByTagName("body")[0];
          if (e.keyCode === 13 && e.target === body) {
            this.loginfn();
          }
        };
      },
      //倒计时
      countDown(s) {
        this.verifyCodeActive = false;
        this.countDownDoing = true;
        var str = `${s}s后再获取`;
        this.verifyCodeStr = str;
        if (!this.countDownIsClose) {
          setTimeout(() => {
            if (s > 1) {
              s--;
              str = `${s}s后再获取`;
              this.countDown(s);
            } else {
              str = `获取验证码`;
              this.countDownDoing = false;
              this.verifyCodeActive = true;
            }
            this.verifyCodeStr = str;
          }, 1000);
        } else {
          str = `获取验证码`;
          this.countDownDoing = false;
          this.verifyCodeActive = true;
          return false;
        }
      },
      //记住密码
      setCookie(c_name, c_pwd, c_vcode, exdays) {
        var exdate = new Date();
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);
        window.document.cookie =
          "username" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
        window.document.cookie =
          "password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
        window.document.cookie =
          "verifyCodeActive" +
          "=" +
          c_vcode +
          ";path=/;expires=" +
          exdate.toGMTString();
      },
      //读取cookie
      getCookie() {
        if (document.cookie.length > 0) {
          var arr = document.cookie.split("; ");
          for (var i = 0; i < arr.length; i++) {
            var arr2 = arr[i].split("=");
            if (arr2[0] == "username") {
              this.login_form.username = arr2[1];
              this.pwChecked = true;
              this.verifyCodeActive = true;
              // console.log(this.pwChecked)
              // console.log(this.verifyCodeActive)
            } else if (arr2[0] == "password") {
              this.login_form.password = arr2[1];
            } else if (arr2[0] == "verifyCodeActive") {
              this.verifyCodeActive = arr2[1];
            }
          }
        }
      },
      //清除cookie
      clearCookie() {
        this.setCookie("", "", "", -1);
      },
    },
  };
</script>
<style lang="less">
  .el-tooltip__popper.is-light {
    border: none;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: rgba(255, 101, 41, 1);
    line-height: 18px;
    border-radius: 10px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
    z-index: -9999;
  }

  .el-tooltip__popper.is-light[x-placement^="right"] .popper__arrow {
    border-right-color: #ffffff;
  }

  .login {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url(../assets/images/login_bg.png) right center/80% 80% no-repeat;
    .el-form {
      background-color: #ffffff;
      border-radius: 0 10px 10px 0;
    }
    .login-title {
      height: 53px;
      text-align: center;
      color: #081234;
      font-size: 18px;
      font-weight: bold;
      padding-top: 64px;
    }
    .login-logo {
      width: 161px;
      height: 53px;
      left: 40px;
    }
    .system-name {
      width: 157px;
      height: 53px;
      right: 60px;
    }
    .login-body {
      padding: 63px 48px 0;
      box-sizing: border-box;
      .pw-wrap {
        margin-top: -20px;
        margin-bottom: 50px;
        padding-left: 6px;
        width: 100%;
        text-align: right;
        font-size: 12px;
        box-sizing: border-box;
        .el-checkbox {
          float: left;
          width: 14px;
          height: 14px;
          border-radius: 14px !important;
        }
        .el-checkbox__input.is-checked .el-checkbox__inner {
          background-color: #ff3b39 !important;
          border-color: #ff3b39 !important;
        }
        .el-checkbox__input .el-checkbox__inner {
          border-radius: 14px !important;
        }
        .el-checkbox__label {
          color: #081234;
          font-size: 12px;
        }
        .el-link--inner {
          color: #2e71fe;
          font-size: 12px;
        }
        .el-link.is-underline:hover:after {
          border-bottom: none;
        }
      }
      .el-form-item {
        padding-left: 0;
        // width: 280px;
        height: 46px;
        // background: #f6f8fb;
        border-radius: 5px;
        box-sizing: border-box;
        margin-bottom: 40px;
        &.Subactive {
          background: #ff3b39;
          .el-button {
            color: #ffffff;
          }
        }
        &.Codeactive {
          .el-input-group__append,
          .el-input-group__prepend {
            width: 130px;
            color: #ffffff;
            background-color: #ff3b39 !important;
            cursor: pointer;
            border-radius: 5px;
          }
          .el-input {
            border: 1px solid transparent;
          }
        }
        .el-form-item__content {
          height: 100%;
          margin-left: 0 !important;
          .el-button {
            width: 100%;
            height: 100%;
            border: none;
            background-color: transparent;
          }
          .el-input__prefix {
            left: 14px;
          }
          .el-icon-user-solid {
            width: 14px;
          }
          .el-input {
            height: 45px;
            padding-left: 14px;
            border: 1px solid #9ea6bc;
            border-radius: 5px;
            box-sizing: border-box;
            .el-input__inner {
              height: 100%;
              // line-height: 100%; // 修复元素在firefox上移问题@lcz
              border: none;
              background-color: transparent;
              font-size: 14px;
            }
            .el-input__icon {
              color: rgb(158, 166, 188);
              font-size: 22px;
              line-height: 45px;
            }
            .el-input-group__append,
            .el-input-group__prepend {
              position: absolute;
              width: 130px;
              height: 100%;
              top: 0;
              right: -150px;
              padding: 0 !important;
              border: none;
              background-color: #edeff2;
              display: flex;
              align-items: center;
              justify-content: center;
              // border-radius: 0 23px 23px 0;
              .el-button {
                width: 100%;
                height: 100%;
                padding: 0;
              }
            }
          }
          // 聚焦
          .el-input:focus-within {
            // border-radius: 23px;
            border: 1px solid #ff3b39;
            box-sizing: border-box;
          }
        }
      }
    }
  }
  .login__bg {
    position: absolute;
    width: 1180px;
    height: 590px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    box-shadow: 0px 12px 35px 0px rgba(254, 121, 113, 0.57);
    border-radius: 0px 20px 20px 0px;
    background-color: #fff;
  }
  .login-form {
    height: 100%;
  }
  .copyright-txt {
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #747b94;
  }
  .login__left {
    width: 700px;
    height: 684px;
  }
  .login-btn {
    background: #ff3b39;
    .el-button {
      color: #fff;
    }
  }

  .verify-code-input {
    width: 230px;
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue